import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";
import { CreateUserResponseDto } from "../interfaces/createUserResponseDto";

export interface CreateUserRequestProps {
  login: string;
  code?: string;
  password?: string;
  username?: string;
  phone?: string;
}

export const createUser = (data: CreateUserRequestProps) =>
  axiosInstance.post<CreateUserResponseDto>(LIGIN_API_URL.createUser(), data);
